import {IInativacaoDeInscricao, IConsultaParaInativacao } from '../interfaces/IInativacaoDeInscricao';
import { apiDaInscricao } from './axios';

const consultarInscricaoParaInativacao = async (inscricaoId: Number):Promise<IConsultaParaInativacao> => {
  return await apiDaInscricao().get(`/InativarInscricao/consultar?idDaInscricao=${inscricaoId}`);
};

const finalizarInativacaoDeInscricao = async (payload: IInativacaoDeInscricao) => {
  await apiDaInscricao().post('/InativarInscricao/inativar', payload);
};

export { consultarInscricaoParaInativacao, finalizarInativacaoDeInscricao };